import { render, staticRenderFns } from "./pQuick.vue?vue&type=template&id=c658b9c2"
import script from "./pQuick.vue?vue&type=script&lang=js"
export * from "./pQuick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports